import { useContext } from 'react';

import { BoardIdContext } from './BoardIdContext';

export const useBoardId = () => {
  const boardId = useContext(BoardIdContext);

  if (boardId === null) {
    throw new Error(
      'Could not find board ID in the React context. Did you forget to wrap the root component in a <BoardIdProvider>?',
    );
  }

  return boardId;
};
